// Navbar file

import Container from "../ui/Container";
import ulfaLogo from "../../assets/logos/ulfa-logo.png";

export default function Navbar() {
  return (
    <header className="fixed left-0 top-0 z-50 w-full border-b border-white/10 bg-white/95 text-twilight-indigo-950 backdrop-blur">
      <Container>
        <nav className="flex h-16 items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-full border border-twilight-indigo-200 bg-white">
              <img
                src={ulfaLogo}
                alt="ULFA Logo"
                className="h-14 w-14 object-contain"
              />
            </div>

            <div>
              <p className="text-xs font-bold uppercase tracking-[0.25em]">
                ULFA
              </p>
              <p className="hidden text-[10px] uppercase tracking-[0.2em] text-slate-500 sm:block">
                Inauguration 2026
              </p>
            </div>
          </a>

          <div className="hidden items-center gap-8 text-xs font-semibold uppercase tracking-[0.25em] md:flex">
            <a href="#program" className="transition hover:text-burnt-tangerine-500">
              Program
            </a>
            <a href="#officials" className="transition hover:text-burnt-tangerine-500">
              Officials
            </a>
            {/* <a href="#register" className="transition hover:text-burnt-tangerine-500">
              Register
            </a> */}
            <a href="#downloads" className="transition hover:text-burnt-tangerine-500">
              Downloads
            </a>
          </div>

          <a
            href="#officials"
            className="rounded-full bg-amber-flame-500 px-5 py-2 text-xs font-bold uppercase tracking-[0.2em] text-twilight-indigo-950 transition hover:bg-amber-flame-400"
          >
            New Leadership
          </a>
        </nav>
      </Container>
    </header>
  );
}